import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import {
  EditLocalization,
  EditLocalizationResponse,
} from "src/Pages/Company/OrganizationStructure/Localizations/localizations.models";
import { editLocalization } from "src/Pages/Company/OrganizationStructure/api";

const useEditLocalization = (companyId: string, structureId: string) => {
  const queryClient = useQueryClient();

  return useMutation<
    EditLocalizationResponse,
    Error,
    { localizationId: string; formData: EditLocalization }
  >({
    mutationFn: async ({ localizationId, formData }) =>
      editLocalization({
        companyId,
        structureId,
        localizationId,
        formData,
      }),

    onSuccess: () => {
      dynamicNotification(
        __("Pomyślnie zaktualizowano lokalizację"),
        "success"
      );

      queryClient.invalidateQueries({
        queryKey: ["localizations-list", companyId, structureId],
      });
    },

    onError: () => {
      dynamicNotification(
        __("Nie udało się zaktualizować lokalizacji"),
        "error"
      );
    },
  });
};

export default useEditLocalization;
